import api from './api'

export interface StatTrend {
  value: number
  positive: boolean
}

export interface MonthlyRevenue {
  month: string
  thisYear: number
  lastYear: number
}

export interface SubmittedEstimate {
  id: string
  title: string
  clientName?: string
  total: number
  createdAt: string
  estimatorName: string
}

export interface WinByCategory {
  type: string
  label: string
  revenue: number
}

export interface AssignedRfp {
  id: string
  rfpNumber?: string
  title: string
  createdAt: string
  isOverdue: boolean
}

export interface RfpQueueItem {
  id: string
  rfpNumber?: string
  title: string
  createdAt: string
}

export interface EstimateInProgressItem {
  id: string
  title: string
  clientName?: string
  total: number
  status: string
  createdAt: string
}

export interface WaitingForSignatureItem {
  id: string
  proposalNumber?: string
  title: string
  clientName?: string
  estimatedValue: number
  sentAt?: string
}

export interface DashboardStats {
  totalRevenue: { value: number; trend: StatTrend | null }
  totalBids: { value: number; trend: StatTrend | null }
  bidsWon: { value: number; trend: StatTrend | null }
  closeRate: { value: number; trend: StatTrend | null }
  monthlyRevenue: MonthlyRevenue[]
  currentMonthRevenue: number
  rfpQueueCount: number
  rfpQueueItems: RfpQueueItem[]
  estimatesInProgressCount: number
  estimatesInProgressItems: EstimateInProgressItem[]
  waitingForSignatureCount: number
  waitingForSignatureItems: WaitingForSignatureItem[]
  submittedForApproval: SubmittedEstimate[]
  winsByCategory: WinByCategory[]
  assignedRfps: AssignedRfp[]
}

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    const { data } = await api.get('/dashboard/stats')
    return data.data
  },
}
